import { useSelector } from 'react-redux';
import { ApplicationState } from '../rootStore';

export const useSupplierInventoryWarehouseStatusReducer = () =>
  useSelector((state: ApplicationState) => state.supplierInventoryWarehouseStatus);
